import lodash from 'lodash';
import moment from 'moment';
import { LEAD_SOURCE_LEADOMATIC } from '../../../../common/constants';
import { checkIsLeadManageLeadomatic, checkIsLeadManageDeliveryRequested } from '.';
import { LEAD_STATUS } from '../../constants/leadStatuses';

export const getAllowedDivisionIds = (rootState) => {
    const userDivisions = lodash.get(rootState, 'App.App_content.user.divisions') || [];
    return userDivisions.map((division) => division._id).filter((item) => item !== LEAD_SOURCE_LEADOMATIC);
};

export const buildFiltersForLeadsReq = (initialFilters, allowedDivisionIds) => {
    const filters = lodash.merge({}, initialFilters);
    const isLeadomatic = checkIsLeadManageLeadomatic();
    const isDeliveryRequested = checkIsLeadManageDeliveryRequested();

    let created_date;

    if (filters.dateTo && filters.dateFrom) {
        created_date = {
            $gte: moment(filters.dateFrom)
                .startOf('day')
                .valueOf(),
            $lte: moment(filters.dateTo)
                .endOf('day')
                .valueOf(),
        };
    }

    filters.is_duplicate = (filters.hideDuplicate === false || filters.hideDuplicate === undefined) ? undefined : false;
    filters.deleted_date = { $exists: false };

    if (isLeadomatic) {
        filters.ref_lead_source = LEAD_SOURCE_LEADOMATIC;
    } else if (!isDeliveryRequested && !filters.ref_lead_source) {
        filters.ref_lead_source = { $in: allowedDivisionIds };
    }

    if (isDeliveryRequested) {
        filters.ref_lead_status = [LEAD_STATUS.deliveryRequested, LEAD_STATUS.deliveryRequestedTrade];
    }

    if (created_date) {
        filters.created_date = created_date;
    }

    if (filters.ref_lead_affiliate) {
        filters['marketing.ref_lead_affiliate'] = filters.ref_lead_affiliate;
    }

    if (filters.is_part_ex) {
        filters['part_ex.is_part_ex'] = filters.is_part_ex;
    }

    if (filters.is_manager_special) {
        filters.is_manager_special = filters.is_manager_special;
    } else if (filters.ref_lead_status === '5beabfe7f25bf5f49685abfb' || filters.ref_lead_status === '60422adafdfc98e8de82c458' || filters.ref_lead_status === '5fbf6505e4073f744bae3a28') {
        filters.is_manager_special = { $in: [undefined, false, true] };
    } else {
        filters.is_manager_special = { $in: [undefined, false] };
    }

    if (filters.is_trade === true) {
        filters['trade.is_trade'] = filters.is_trade;

        // Trade tab shows leads with is_trade = true and lead_pot !== 'Black'
        // Scrap tab shows leads with is_trade = true and lead_pot === 'Black'
        if (filters.lead_pot !== 'Black') {
            filters.lead_pot = { $ne: 'Black' };
        }
    } else if (filters.is_trade === false) {
        filters['trade.is_trade'] = { $in: [null, false] };
    } else {
        delete filters['trade.is_trade'];
    }

    if (filters.lead_pot && filters.lead_pot === 'All') {
        filters.lead_pot = undefined;
    }

    filters.$expr = { $and: [] };

    // Valuation range — matches latest valuation entry within range
    if (filters.valuationFrom !== undefined || filters.valuationTo !== undefined) {
        filters.valuations = { $exists: true, $not: { $size: 0 } };

        let valuationFromParams = {};
        let valuationToParams = {};

        if (filters.valuationFrom !== undefined) {
            valuationFromParams = { $gte: [{ $arrayElemAt: ['$valuations.valuation', -1] }, Number(filters.valuationFrom)] };
            filters.$expr.$and.push(valuationFromParams);
        }
        if (filters.valuationTo !== undefined) {
            valuationToParams = { $lte: [{ $arrayElemAt: ['$valuations.valuation', -1] }, Number(filters.valuationTo)] };
            filters.$expr.$and.push(valuationToParams);
        }
    }

    // Margin range — matches latest suggested_margin entry within range
    if (filters.marginFrom !== undefined || filters.marginTo !== undefined) {
        filters.valuations = { $exists: true, $not: { $size: 0 } };

        let marginFromParams = {};
        let marginToParams = {};

        if (filters.marginFrom !== undefined) {
            marginFromParams = { $gte: [{ $arrayElemAt: ['$valuations.suggested_margin', -1] }, Number(filters.marginFrom)] };
            filters.$expr.$and.push(marginFromParams);
        }
        if (filters.marginTo !== undefined) {
            marginToParams = { $lte: [{ $arrayElemAt: ['$valuations.suggested_margin', -1] }, Number(filters.marginTo)] };
            filters.$expr.$and.push(marginToParams);
        }
    }

    if (filters.$expr.$and.length === 0) {
        delete filters.$expr;
    }

    return filters;
};

export const clearingFiltersForLeadReq = (initialFilters) => {
    const unnecessaryFields = [
        'dateFrom',
        'dateTo',
        'marginFrom',
        'marginTo',
        'is_leadomatic',
        'is_trade',
        'ref_lead_affiliate',
        'is_hot',
        'hideDuplicate',
        'hide_leadomatic_leads',
        'customer',
        'is_part_ex',
        'is_trade',
        'dateFrom',
        'dateTo',
        'vrm',
        'ref_bike_brand',
        'ref_bike_model',
        'post_code',
        'sortField',
        'sortDirection',
        'mileageFrom',
        'mileageTo',
        'yearFrom',
        'yearTo',
        'valuationFrom',
        'valuationTo',
    ];

    const filters = lodash.merge({}, initialFilters);

    return lodash.omit(filters, unnecessaryFields);
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/utils/buildFiltersForLeadsReq.js